import { render } from "./SupportApp.vue?vue&type=template&id=6132cb66&scoped=true"
import script from "./SupportApp.vue?vue&type=script&lang=js"
export * from "./SupportApp.vue?vue&type=script&lang=js"

import "./SupportApp.vue?vue&type=style&index=0&id=6132cb66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6132cb66"]])

export default __exports__